<ng-container *ngIf="show">
  <div class="modal fade show" tabindex="-1" role="dialog" aria-hidden="true" (click)="close()">
    <div class="wrapper">
      <div class="modal-dialog modal-{{size}}" role="document" (click)="disableClick($event)">
        <div class="modal-content">
          <div class="modal-body">
            <button *ngIf="x" type="button" class="btn-close" aria-label="Close" (click)="close()"></button>
            <ng-content></ng-content>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-backdrop fade show"></div>
</ng-container>